<template>
  <aside>
    <b-nav
      vertical>
      <b-nav-text
        class="text-uppercase text-muted">
        {{ userName }}
      </b-nav-text>
      <b-nav-item
        to="/dashboard">
        <i class="ti-dashboard mx-2"></i>
        <span>{{ $t('message.adminSidebar.navItem.dashboard') }}</span>
      </b-nav-item>
      <b-nav-item
        to="/admin/users">
        <i class="ti-user mx-2"></i>
        <span>{{ $t('message.adminSidebar.navItem.users') }}</span>
      </b-nav-item>
      <b-nav-item
        to="/admin/contractpartners">
        <i class="ti-agenda mx-2"></i>
        <span>{{ $t('message.adminSidebar.navItem.contractPartners') }}</span>
      </b-nav-item>
      <b-nav-item
        to="/account">
        <i class="ti-settings mx-2"></i>
        <span>{{ $t('message.adminSidebar.navItem.account') }}</span>
      </b-nav-item>
    </b-nav>
  </aside>
</template>

<script>
  export default {
    name: 'AdminSidebar',
    computed: {
      userName () {
        const currentUser = this.$store.getters.currentUser
        return `${currentUser.firstName} ${currentUser.lastName}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminSidebar.vue